module.exports = __webpack_public_path__ + "img/welfare_bg.f240d511.png";